import Constants from '@intercom/embercom-composer/lib/constants';
import { classForType } from '@intercom/embercom-composer/blocks/types/base/block';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
function BlockReplacer(block, replacement) {
  this.block = block;
  this.replacement = replacement;
}
BlockReplacer.prototype = {
  doReplacement(mutationResult) {
    let blocksToRemove = [];
    let blocksToAdd = [];
    let match = this.block.get('text').match(this.replacement.pattern);
    if (match && this._isReplacementAllowed(match)) {
      let options = this._extractOptionsFromMatch(match);
      blocksToAdd.pushObject(this._createBlockForReplacement(match, options));
      this.block.delete(BlockRange.atPositionIndex(match.index, match.index + match[0].length));
      if (this.block.get('text') === '') {
        blocksToRemove.pushObject(this.block);
      } else {
        this._splitBlockForReplacement(match, blocksToAdd, blocksToRemove);
      }
      mutationResult.setProperties({
        blockRange: BlockRange.atPositionIndex(0),
        blocksToAdd,
        blocksToRemove
      });
    }
    return mutationResult;
  },
  _isReplacementAllowed(match) {
    if (this.replacement.config && !this.block.get(`config.${this.replacement.config}`)) {
      return false;
    }
    return this.block.get(`config.allow${this.replacement.replaceWith}`) && !this.block.get('replacementsToSkip').includes(match[1]);
  },
  _extractOptionsFromMatch(match) {
    let options = {};
    if (match.length > 1) {
      // replacement had capture groups
      for (let i = 1; i <= match.length; i++) {
        let key = this.replacement.captureGroupMapping[i - 1];
        let value = match[i];
        if (!value && key && key.match(/text/)) {
          value = '';
        }
        if (key !== undefined) {
          options[key] = value;
        }
      }
    }
    return options;
  },
  _createBlockForReplacement(match, options) {
    let newBlock = classForType(this.replacement.replaceWith).create({
      config: this.block.get('config')
    });
    newBlock.set('triggerAlignment', this.block.get('align'));
    newBlock.setProperties(options);
    this._copyEntitiesToReplacementBlock(match, options, newBlock);
    return newBlock;
  },
  _newBlockLengthFromOptions(options) {
    if (options['blockList.firstObject.text'] !== undefined) {
      return options['blockList.firstObject.text'].length;
    } else if (options['text'] !== undefined) {
      return options.text.length;
    } else {
      return 0;
    }
  },
  _copyEntitiesToReplacementBlock(match, options, newBlock) {
    let newBlockLength = this._newBlockLengthFromOptions(options);
    let matchStartIndex = match.index;
    let matchEndIndex = match.index + match[0].length;
    let matchLength = matchEndIndex - matchStartIndex;
    let droppedCharacterLength = matchLength - newBlockLength;
    let entities = this.block.get('entities');
    let entitiesInReplacementRange = entities.withinRange(BlockRange.atPositionIndex(matchStartIndex, matchEndIndex));
    let shiftedEntities = [];
    entitiesInReplacementRange.forEach(function (entity) {
      if (entity.get('endIndex') === matchStartIndex || entity.get('startIndex') === matchEndIndex) {
        // don't copy adjacent entities
        return;
      }
      let entityCopy = entity.copy();
      entityCopy.shiftLeftBy(matchStartIndex + droppedCharacterLength);
      if (entityCopy.get('endIndex') < 0) {
        return;
      }
      if (entityCopy.get('startIndex') < 0) {
        entityCopy.set('startIndex', 0);
      }
      if (entityCopy.get('endIndex') > newBlockLength) {
        entityCopy.set('endIndex', newBlockLength);
      }
      shiftedEntities.pushObject(entityCopy);
    });
    let targetBlock;
    if (newBlock.get('isListType')) {
      targetBlock = newBlock.get('blockList.firstObject');
    } else {
      targetBlock = newBlock;
    }
    // Apply the entities rather than just copying the array so the target block
    // can decide if it actually wants these entities (e.g. a code block)
    shiftedEntities.forEach(function (entity) {
      targetBlock.toggleEntity(entity.get('type'), BlockRange.atPositionIndex(entity.get('startIndex'), entity.get('endIndex')), entity.get('options'));
    });
  },
  _splitBlockForReplacement(match, blocksToAdd, blocksToRemove) {
    let block = this.block.split(BlockRange.atPositionIndex(match.index));
    let blockText;
    if (!block.get('isEmpty')) {
      blockText = block.get('text');
      if (blockText.charAt(0) === Constants.NEW_LINE) {
        block.delete(BlockRange.atPositionIndex(0, 1));
      }
      blocksToAdd.pushObject(block);
    }
    if (this.block.get('isEmpty')) {
      blocksToRemove.pushObject(this.block);
    }
  }
};
export default BlockReplacer;